import styled from 'styled-components';
import LeftArrowIconHome from '../assets/hotels/home/arrow-left.svg';

const LeftArrowIcon = styled(LeftArrowIconHome as React.SFC<React.SVGProps<SVGSVGElement>>)`
  fill: ${props =>
    props.isactive === 'true'
      ? props.theme.colors.goBrand.blue
      : props.theme.colors.blue.bgBlueLight};
  width: ${props => '1.6rem'};
  height: ${props => '1.6rem'};
`;

export default LeftArrowIcon;
